import { history } from '../../index';

export default function navigateTo(path: string, nextFcn?: any) {
    history.push(path)

    if(typeof nextFcn !== 'undefined')  {
        nextFcn()
    }
}